import React, { useEffect } from 'react';
import { TopicStyles } from './mixins/mixins';
import { AppearanceStyle } from './appearanceStyle';
import { WallpaperStyle } from './wallpaperStyle';
import { BookmarksStyle } from './bookmarksStyle/bookmarksStyle';
import { ClockStyle } from './clockStyle';
import { FeaturesStyle } from './featuresStyle';
import { IntegraionStyle } from './integrationsStyle';
import { SidebarStyle } from './sidebarStyle';
import DefaultBookmarkList from './bookmarksStyle/defaultBookmarkList';
import { SearchBarStyle } from './searchbarStyle/searchBarStyle';
import { QuoteStyle } from './quoteStyle';

export type TopicStylesProps = {
	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
	setIsValid: (isValid: boolean) => void;
};

export default function TopicStyle(props: TopicStylesProps) {
	useEffect(() => {
		console.log(props.style);
	}, [props.style]);

	return (
		<div>
			<h3 className="text-center mt-3 sm:mt-2 text-xl sm:text-6xl font-bold text-gray-600 dark:text-gray-500">
				Topic Style
			</h3>

			<div className="mx-auto border-t w-10/12 mt-5 mb-5 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center" />

			<h3 className="text-left pl-18 mt-3 mb-4 sm:mt-2 text-xl sm:text-3xl font-bold text-gray-600 dark:text-gray-500">
				Appearance
			</h3>

			<AppearanceStyle style={props.style} setStyle={props.setStyle} />

			<div className="mx-auto border-t w-10/12 mt-5 mb-5 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center" />

			<h3 className="text-left pl-18 -mt-3 mb-4 sm:mt-2 text-xl sm:text-3xl font-bold text-gray-600 dark:text-gray-500">
				Wallpaper Style
			</h3>
			<WallpaperStyle style={props.style} setStyle={props.setStyle} />

			<div className="mx-auto border-t w-10/12 mt-5 mb-5 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center" />

			<h3 className="text-left pl-18 -mt-3 mb-4 sm:mt-2 text-xl sm:text-3xl font-bold text-gray-600 dark:text-gray-500">
				Sidebar Style
			</h3>
			<SidebarStyle style={props.style} setStyle={props.setStyle} />

			<div className="mx-auto border-t w-10/12 mt-5 mb-5 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center" />

			<h3 className="text-left pl-18 -mt-3 mb-4 sm:mt-2 text-xl sm:text-3xl font-bold text-gray-600 dark:text-gray-500">
				Clock Style
			</h3>
			<ClockStyle style={props.style} setStyle={props.setStyle} />

			<div className="mx-auto border-t w-10/12 mt-5 mb-5 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center" />

			<h3 className="text-left pl-18 -mt-3 mb-4 sm:mt-2 text-xl sm:text-3xl font-bold text-gray-600 dark:text-gray-500">
				Features Style
			</h3>
			<FeaturesStyle style={props.style} setStyle={props.setStyle} />

			<div className="mx-auto border-t w-10/12 mt-5 mb-5 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center" />

			<h3 className="text-left pl-18 -mt-3 mb-4 sm:mt-2 text-xl sm:text-3xl font-bold text-gray-600 dark:text-gray-500">
				Quote Style
			</h3>
			<QuoteStyle style={props.style} setStyle={props.setStyle} />

			<div className="mx-auto border-t w-10/12 mt-5 mb-5 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center" />

			<h3 className="text-left pl-18 -mt-3 mb-4 sm:mt-2 text-xl sm:text-3xl font-bold text-gray-600 dark:text-gray-500">
				Integrations
			</h3>
			<IntegraionStyle style={props.style} setStyle={props.setStyle} />

			<div className="mx-auto border-t w-10/12 mt-5 mb-5 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center" />

			<h3 className="text-left pl-18 -mt-3 mb-4 sm:mt-2 text-xl sm:text-3xl font-bold text-gray-600 dark:text-gray-500">
				Bookmarks Style
			</h3>
			<BookmarksStyle style={props.style} setStyle={props.setStyle} />

			<DefaultBookmarkList
				style={props.style}
				setStyle={props.setStyle}
				setIsValid={props.setIsValid}
			/>

			<div className="mx-auto border-t w-10/12 mt-5 mb-5 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center" />

			<h3 className="text-left pl-18 -mt-3 mb-4 sm:mt-2 text-xl sm:text-3xl font-bold text-gray-600 dark:text-gray-500">
				Searchbar Style
			</h3>
			<SearchBarStyle style={props.style} setStyle={props.setStyle} />
		</div>
	);
}
